<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title aling="center">Evaluación de Desempeño: {{datosEv.descripcion}}</v-toolbar-title>
      </v-toolbar>
    <v-card>
        <v-card-text>    
          <v-container>
              <v-row>
                <v-col cols="4">
                    Inicio: {{evfecini}}
                </v-col>
                <v-col cols="4">
                    Fin: {{evfecfin}}
                </v-col>
                <v-col cols="4">
                    Faltan: {{faltan()}} dias para finalizar.
                </v-col>
                
                <v-col cols="6">
                    Colaborador: 
                    <v-avatar  size="30">
                      <img :src="evaluado.img ? evaluado.img : api+'uploads/default-user-image.png'" alt="Foto">
                    </v-avatar>
                      {{evaluado.name}}
                </v-col>

                <v-col cols="6">
                    Responsable Actual: 
                    <v-avatar  size="30">
                      <img :src="responsable.img ? responsable.img : api+'uploads/default-user-image.png'" alt="Foto">
                    </v-avatar>
                    {{responsable.name}}
                </v-col>
              </v-row>
          </v-container>
        </v-card-text>
    </v-card>
    <v-alert type="warning" v-if="responsable == 'Recursos Humanos'">
      Esta Evaluacion de Desempeño presenta una disconformidad y ha sido rechazada
    </v-alert>

<v-stepper v-if="evpaso>0" :value="evpaso" alt-labels>
    <v-stepper-header>
      <template v-for='paso in pasos'>
        <v-stepper-step :step="paso.step" :key="paso.step" :rules="paso.rechazo ? [() => false] : [() => true]"
        :complete="(evpaso > paso.step) ? true : false">{{paso.descrip}}</v-stepper-step>
        <v-divider v-if="paso.step !== pasos.length" :key="paso.descrip"></v-divider>
      </template>
    </v-stepper-header>

    <v-stepper-items>
        <v-stepper-content :step="pflujo">
            <v-tabs>
                <v-tab align-with-title="true" v-if="evcompetencias > 0" @click="rep('com')">
                    <v-icon left>mdi-elevation-rise</v-icon>
                    Competencias ({{sumCom}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="evobjetivos > 0" @click="rep('obj')">
                    <v-icon left>mdi-code-equal</v-icon>
                    Objetivos ({{sumObj}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="comentarios.length > 0">
                    <v-icon left>mdi-comment-multiple-outline</v-icon>
                    Comentarios
                </v-tab>
                <v-tab style="align-content: flex-start;">
                    <v-icon left>mdi-folder-multiple</v-icon>
                    Respaldos
                </v-tab>

                <v-tab-item v-if="evcompetencias > 0">
                  <v-btn absolute dark fab top right color="success" @click="dialog = true" v-if="sumCom < 100">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <objcom :datosObjCom="datosCom" :editable="data.idturno == user.emp.id ? true: false" 
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                </v-tab-item>

                <v-tab-item v-if="evobjetivos > 0">
                    <v-btn absolute dark fab top right color="success" @click="dialog = true" v-if="sumObj < 100">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  <objcom :datosObjCom="datosObj" :editable="data.idturno == user.emp.id ? true: false"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                </v-tab-item>

                <v-tab-item v-if="comentarios.length > 0">
                  <coment :comentarios="comentarios"/>
                </v-tab-item>
                
                <v-tab-item>
                  <archivos :archivos="soportes" @cargaArchivos="cargaArchivos($event)" :respaldo="datosEv.res_col"/>
                </v-tab-item>

            </v-tabs>

          <v-spacer></v-spacer>
            <br><br>
          <v-btn absolute dark bottom right color="success" @click="observaciones(pflujo+1,true)" v-if="enviarPaso1 & data.idturno == user.emp.id & date >= datosEv.fechainicio_col">
            Enviar a revision
          </v-btn>                        

        </v-stepper-content>

        <v-stepper-content :step="prevision">
            <v-tabs>
                <v-tab align-with-title="true" v-if="evcompetencias > 0" @click="rep('com')">
                    <v-icon left>mdi-elevation-rise</v-icon>
                    Competencias ({{sumCom}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="evobjetivos > 0" @click="rep('obj')">
                    <v-icon left>mdi-code-equal</v-icon>
                    Objetivos ({{sumObj}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="comentarios.length > 0">
                    <v-icon left>mdi-comment-multiple-outline</v-icon>
                    Comentarios
                </v-tab>
                <v-tab style="align-content: flex-start;">
                    <v-icon left>mdi-folder-multiple</v-icon>
                    Respaldos
                </v-tab>

                <v-tab-item v-if="evcompetencias > 0">
                  <v-btn absolute dark fab top right color="success" @click="dialog = true" v-if="sumCom < 100">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>                  
                  <objcom :datosObjCom="datosCom" :editable="data.idturno == user.emp.id ? true: false"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                </v-tab-item>

                <v-tab-item v-if="evobjetivos > 0">
                  <v-btn absolute dark fab top right color="success" @click="dialog = true" v-if="sumObj < 100">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>                  
                  <objcom :datosObjCom="datosObj" :editable="data.idturno == user.emp.id ? true: false"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                </v-tab-item>

                <v-tab-item v-if="comentarios.length > 0">
                  <coment :comentarios="comentarios"/>
                </v-tab-item>

                <v-tab-item>
                  <archivos :archivos="soportes" @cargaArchivos="cargaArchivos($event)" :respaldo="datosEv.res_sup"/>
                </v-tab-item>                
            </v-tabs>

          <v-spacer></v-spacer>
            <br><br>
          <v-btn absolute dark bottom left color="warning" @click="observaciones(prevision-1)" v-if="datosEv.emp.idsupervisor == user.emp.id">
            Devolver a Etapa Anterior
          </v-btn>   
            <v-spacer></v-spacer>
          <v-btn absolute dark bottom right color="success" @click="observaciones(prevision+1,true)" v-if="enviarPaso1 & datosEv.emp.idsupervisor == user.emp.id & date >= datosEv.fechainicio_sup">
            Aprobar y Enviar a siguiente etapa
          </v-btn>                    

        </v-stepper-content>

        <v-stepper-content :step="pev_med_col">
            <v-tabs>
                <v-tab align-with-title="true" v-if="evcompetencias > 0" @click="rep('com')">
                    <v-icon left>mdi-elevation-rise</v-icon>
                    Competencias ({{sumCom}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="evobjetivos > 0" @click="rep('obj')">
                    <v-icon left>mdi-code-equal</v-icon>
                    Objetivos ({{sumObj}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="comentarios.length > 0">
                    <v-icon left>mdi-comment-multiple-outline</v-icon>
                    Comentarios
                </v-tab>
                <v-tab style="align-content: flex-start;">
                    <v-icon left>mdi-folder-multiple</v-icon>
                    Respaldos
                </v-tab>

                <v-tab-item v-if="evcompetencias > 0">
                  <v-btn absolute dark fab top right color="success" @click="dialog = true" v-if="sumCom < 100">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>                  
                  <objcom :datosObjCom="datosCom" :editable="data.idturno == user.emp.id ? true: false" :escala="escala" :calificacioncol="data.idturno == user.emp.id ? true : false" :medioano="true" :colaborador="data.idturno == user.emp.id ? true : false"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                  <calificacion :comobj="datosCom" :tipo="'Competencias'" :valor="datosEv.bcompetencias" v-if="comEval"/>
                </v-tab-item>

                <v-tab-item v-if="evobjetivos > 0">
                  <v-btn absolute dark fab top right color="success" @click="dialog = true" v-if="sumObj < 100">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>                  
                  <objcom :datosObjCom="datosObj" :editable="data.idturno == user.emp.id ? true: false" :escala="escala" :calificacioncol="data.idturno == user.emp.id ? true : false" :medioano="true" :colaborador="data.idturno == user.emp.id ? true : false"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                  <calificacion :comobj="datosObj" :tipo="'Objetivos'" :valor="datosEv.bobjetivos" v-if="objEval"/>
                </v-tab-item>

                <v-tab-item v-if="comentarios.length > 0">
                  <coment :comentarios="comentarios"/>
                </v-tab-item>

                <v-tab-item>
                  <archivos :archivos="soportes" @cargaArchivos="cargaArchivos($event)" :respaldo="datosEv.res_med_col"/>
                </v-tab-item>                
            </v-tabs>
          
          
            <br><br> 
            <v-spacer></v-spacer>
            <v-row>

              <v-col cols="8">
                <v-btn absolute dark bottom right color="success" @click="validarcal('medcol',pev_med_col+1)" v-if="enviarPaso1 && data.idturno == user.emp.id && date >= datosEv.fechainicio_med_col">
                  Calificar y Enviar a siguiente etapa
                </v-btn>
              </v-col>
            </v-row>
          

        </v-stepper-content>

        <v-stepper-content :step="pev_med_sup">
            <v-tabs>
                <v-tab align-with-title="true" v-if="evcompetencias > 0" @click="rep('com')">
                    <v-icon left>mdi-elevation-rise</v-icon>
                    Competencias ({{sumCom}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="evobjetivos > 0" @click="rep('obj')">
                    <v-icon left>mdi-code-equal</v-icon>
                    Objetivos ({{sumObj}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="comentarios.length > 0">
                    <v-icon left>mdi-comment-multiple-outline</v-icon>
                    Comentarios
                </v-tab>
                <v-tab style="align-content: flex-start;">
                    <v-icon left>mdi-folder-multiple</v-icon>
                    Respaldos
                </v-tab>

                <v-tab-item v-if="evcompetencias > 0">
                  <v-btn absolute dark fab top right color="success" @click="dialog = true" v-if="sumCom < 100">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>                  
                  <objcom :datosObjCom="datosCom" :editable="data.idturno == user.emp.id ? true: false" :escala="escala" :calificacioncol="datosEv.autoevaluacion == 1 ? true : false" :calificacionsup="data.idturno == user.emp.id ? true : false" :medioano="true" :supervisor="data.idturno == user.emp.id ? true : false"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                  <calificacion :comobj="datosCom" :tipo="'Competencias'" :valor="datosEv.bcompetencias" v-if="comEval"/>
                </v-tab-item>

                <v-tab-item v-if="evobjetivos > 0">
                  <v-btn absolute dark fab top right color="success" @click="dialog = true" v-if="sumObj < 100">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>                  
                  <objcom :datosObjCom="datosObj" :editable="data.idturno == user.emp.id ? true: false" :escala="escala" :calificacioncol="datosEv.autoevaluacion == 1 ? true : false" :calificacionsup="data.idturno == user.emp.id ? true : false" :medioano="true" :supervisor="data.idturno == user.emp.id ? true : false"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                  <calificacion :comobj="datosObj" :tipo="'Objetivos'" :valor="datosEv.bobjetivos" v-if="objEval"/>
                </v-tab-item>

                <v-tab-item v-if="comentarios.length > 0">
                  <coment :comentarios="comentarios"/>
                </v-tab-item>

                <v-tab-item>
                  <archivos :archivos="soportes" @cargaArchivos="cargaArchivos($event)" :respaldo="datosEv.res_med_sup"/>
                </v-tab-item>                
            </v-tabs>
            <br><br> 
            <v-row>
              <v-col cols="6">
                <v-select :items="escala" v-model="autoescala2" label="Favor Evalue al Colaborador" outlined v-if="data.idturno == user.emp.id"></v-select>
              </v-col>
              <v-col cols="12">
                <v-btn absolute dark bottom left color="warning" @click="observaciones(pev_med_sup-1)" v-if="data.idturno == user.emp.id">
                  Devolver a Etapa Anterior
                </v-btn>   
                  <v-spacer></v-spacer>                 
                <v-btn absolute dark bottom right color="success" @click="validarcal('medsup',pev_med_sup+1,autoescala2)" v-if="enviarPaso1 & data.idturno == user.emp.id & date >= datosEv.fechainicio_med_sup">
                  Calificar y Enviar a siguiente etapa
                </v-btn>                        
              </v-col>
            </v-row>
          
        </v-stepper-content>

        <v-stepper-content :step="pev_fin_col">
            <v-tabs>
                <v-tab align-with-title="true" v-if="evcompetencias > 0" @click="rep('com')">
                    <v-icon left>mdi-elevation-rise</v-icon>
                    Competencias ({{sumCom}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="evobjetivos > 0" @click="rep('obj')">
                    <v-icon left>mdi-code-equal</v-icon>
                    Objetivos ({{sumObj}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="comentarios.length > 0">
                    <v-icon left>mdi-comment-multiple-outline</v-icon>
                    Comentarios
                </v-tab>
                <v-tab style="align-content: flex-start;">
                    <v-icon left>mdi-folder-multiple</v-icon>
                    Respaldos
                </v-tab>

                <v-tab-item v-if="evcompetencias > 0">
                  <v-btn absolute dark fab top right color="success" @click="dialog = true" v-if="sumCom < 100">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>                 
                  <objcom :datosObjCom="datosCom" :editable="data.idturno == user.emp.id ? true: false" :escala="escala" :calificacioncol="true" :calificacionsup="true" :medioano="true" :finano="true" :colaborador="data.idturno == user.emp.id ? true : false"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                  <calificacion :comobj="datosCom" :tipo="'Competencias'" :valor="datosEv.bcompetencias" v-if="comEval"/>
                </v-tab-item>

                <v-tab-item v-if="evobjetivos > 0">
                  <v-btn absolute dark fab top right color="success" @click="dialog = true" v-if="sumObj < 100">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>                  
                  <objcom :datosObjCom="datosObj" :editable="data.idturno == user.emp.id ? true: false" :escala="escala" :calificacioncol="true" :calificacionsup="true" :medioano="true" :finano="true" :colaborador="data.idturno == user.emp.id ? true : false"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                  <calificacion :comobj="datosObj" :tipo="'Objetivos'" :valor="datosEv.bobjetivos" v-if="objEval"/>
                </v-tab-item>

                <v-tab-item v-if="comentarios.length > 0">
                  <coment :comentarios="comentarios"/>
                </v-tab-item>

                <v-tab-item>
                  <archivos :archivos="soportes" @cargaArchivos="cargaArchivos($event)" :respaldo="datosEv.res_fin_col"/>
                </v-tab-item>                
            </v-tabs>
            <br><br> 
            <v-row>
              <v-col cols="4" v-if="datosEv.medioano == 1">
                Evaluacion medio Año del supervisor: {{autoescala2}}
              </v-col>
    
              <v-col cols="4">
                <v-btn absolute dark bottom right color="success" @click="validarcal('fincol',pev_fin_col+1)" v-if="enviarPaso1 & data.idturno == user.emp.id & date >= datosEv.fechainicio_fin_col">
                  Calificar y Enviar a siguiente etapa
                </v-btn>                        
              </v-col>
            </v-row>
          
        </v-stepper-content>

        <v-stepper-content :step="pev_fin_sup">
            <v-tabs>
                <v-tab align-with-title="true" v-if="evcompetencias > 0" @click="rep('com')">
                    <v-icon left>mdi-elevation-rise</v-icon>
                    Competencias ({{sumCom}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="evobjetivos > 0" @click="rep('obj')">
                    <v-icon left>mdi-code-equal</v-icon>
                    Objetivos ({{sumObj}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="comentarios.length > 0">
                    <v-icon left>mdi-comment-multiple-outline</v-icon>
                    Comentarios
                </v-tab>
                <v-tab style="align-content: flex-start;">
                    <v-icon left>mdi-folder-multiple</v-icon>
                    Respaldos
                </v-tab>

                <v-tab-item v-if="evcompetencias > 0">
                  <v-btn absolute dark fab top right color="success" @click="dialog = true" v-if="sumCom < 100">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>                  
                  <objcom :datosObjCom="datosCom" :editable="data.idturno == user.emp.id ? true: false" :escala="escala" :calificacioncol="datosEv.autoevaluacion == 1 ? true : false" :calificacionsup="true" :medioano="datosEv.medioano == 1 ? true : false" :finano="true" :supervisor="data.idturno == user.emp.id ? true : false"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                  <calificacion :comobj="datosCom" :tipo="'Competencias'" :valor="datosEv.bcompetencias" v-if="comEval"/>
                </v-tab-item>

                <v-tab-item v-if="evobjetivos > 0">
                  <v-btn absolute dark fab top right color="success" @click="dialog = true" v-if="sumObj < 100">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>                  
                  <objcom :datosObjCom="datosObj" :editable="data.idturno == user.emp.id ? true: false" :escala="escala" :calificacioncol="datosEv.autoevaluacion == 1 ? true : false" :calificacionsup="true" :medioano="datosEv.medioano == 1 ? true : false" :finano="true" :supervisor="data.idturno == user.emp.id ? true : false"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                  <calificacion :comobj="datosObj" :tipo="'Objetivos'" :valor="datosEv.bobjetivos" v-if="objEval"/>
                </v-tab-item>

                <v-tab-item v-if="comentarios.length > 0">
                  <coment :comentarios="comentarios"/>
                </v-tab-item>

                <v-tab-item>
                  <archivos :archivos="soportes" @cargaArchivos="cargaArchivos($event)" :respaldo="datosEv.res_fin_sup"/>
                </v-tab-item>                
            </v-tabs>
            <br><br> 
            <v-row>
              <v-col cols="4" v-if="datosEv.medioano == 1">
                Evaluacion medio Año del supervisor: {{autoescala2}}
              </v-col>
              <v-col cols="4">
                <v-select :items="escala" v-model="autoescala4" label="Favor Evalue al Colaborador" outlined v-if="data.idturno == user.emp.id"></v-select>
              </v-col>
              <v-col cols="12">
                <v-btn absolute dark bottom left color="warning" @click="observaciones(pev_fin_sup-1)" v-if="data.idturno == user.emp.id">
                  Devolver a Etapa Anterior
                </v-btn>   
                  <v-spacer></v-spacer>  
                <v-btn absolute dark bottom right color="success" @click="validarcal('finsup',pev_fin_sup+1,autoescala4)" v-if="enviarPaso1 & data.idturno == user.emp.id & date >= datosEv.fechainicio_fin_sup">
                  Calificar y Enviar a siguiente etapa
                </v-btn>                        
              </v-col>
            </v-row>
          
        </v-stepper-content>

        <v-stepper-content :step="pev_fir_col">
            <v-tabs>
                <v-tab align-with-title="true" v-if="evcompetencias > 0" @click="rep('com')">
                    <v-icon left>mdi-elevation-rise</v-icon>
                    Competencias ({{sumCom}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="evobjetivos > 0" @click="rep('obj')">
                    <v-icon left>mdi-code-equal</v-icon>
                    Objetivos ({{sumObj}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="comentarios.length > 0">
                    <v-icon left>mdi-comment-multiple-outline</v-icon>
                    Comentarios
                </v-tab>
                <v-tab style="align-content: flex-start;">
                    <v-icon left>mdi-folder-multiple</v-icon>
                    Respaldos
                </v-tab>

                <v-tab-item v-if="evcompetencias > 0">
                  <objcom :datosObjCom="datosCom" :editable="data.idturno == user.emp.id ? true: false" :escala="escala" :calificacioncol="datosEv.autoevaluacion == 1 ? true : false" :calificacionsup="true" :medioano="true" :finano="true"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                  <calificacion :comobj="datosCom" :tipo="'Competencias'" :valor="datosEv.bcompetencias" v-if="comEval"/>
                </v-tab-item>

                <v-tab-item v-if="evobjetivos > 0">
                  <objcom :datosObjCom="datosObj" :editable="data.idturno == user.emp.id ? true: false" :escala="escala" :calificacioncol="datosEv.autoevaluacion == 1 ? true : false" :calificacionsup="true" :medioano="true" :finano="true"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                  <calificacion :comobj="datosObj" :tipo="'Objetivos'" :valor="datosEv.bobjetivos" v-if="objEval"/>
                </v-tab-item>

                <v-tab-item v-if="comentarios.length > 0">
                  <coment :comentarios="comentarios"/>
                </v-tab-item>

                <v-tab-item>
                  <archivos :archivos="soportes" @cargaArchivos="cargaArchivos($event)" :respaldo="datosEv.res_fir_col"/>
                </v-tab-item>

            </v-tabs>
            <br><br>
            <v-row>
              <v-col cols="6" v-if="datosEv.medioano == 1">
                Evaluacion medio Año del supervisor: {{autoescala2}}
              </v-col>
              <v-col cols="6">
                Evaluacion fin de Año del Supervisor: {{autoescala4}}
              </v-col>              
              
              <v-col cols="12">
                <v-checkbox v-model="firma1" label="Acepto este proceso de evaluacion y certifico que estoy conforme" v-if="data.idturno == user.emp.id"></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-btn absolute dark bottom left color="warning" @click="observaciones(10)" v-if="data.idturno == user.emp.id">
                  Rechazar Evaluacion por No conformidad
                </v-btn> 
                <v-spacer></v-spacer>
                <v-btn absolute dark bottom right color="success" :disabled="!firma1" @click="observaciones(pev_fir_col+1)" v-if="enviarPaso1 & data.idturno == user.emp.id & date >= datosEv.fechainicio_fir_col">
                  Firmar y Enviar a siguiente etapa
                </v-btn>                        
              </v-col>
            </v-row>
          
        </v-stepper-content>

        <v-stepper-content :step="pev_fir_sup">
            <v-tabs>
                <v-tab align-with-title="true" v-if="evcompetencias > 0" @click="rep('com')">
                    <v-icon left>mdi-elevation-rise</v-icon>
                    Competencias ({{sumCom}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="evobjetivos > 0" @click="rep('obj')">
                    <v-icon left>mdi-code-equal</v-icon>
                    Objetivos ({{sumObj}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="comentarios.length > 0">
                    <v-icon left>mdi-comment-multiple-outline</v-icon>
                    Comentarios
                </v-tab>
                <v-tab style="align-content: flex-start;">
                    <v-icon left>mdi-folder-multiple</v-icon>
                    Respaldos
                </v-tab>

                <v-tab-item v-if="evcompetencias > 0">
                  <objcom :datosObjCom="datosCom" :editable="false" :escala="escala" :calificacioncol="datosEv.autoevaluacion == 1 ? true : false" :calificacionsup="true" :medioano="datosEv.medioano == 1 ? true : false" :finano="true"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                  <calificacion :comobj="datosCom" :tipo="'Competencias'" :valor="datosEv.bcompetencias" v-if="comEval"/>
                </v-tab-item>

                <v-tab-item v-if="evobjetivos > 0">
                  <objcom :datosObjCom="datosObj" :editable="false" :escala="escala" :calificacioncol="datosEv.autoevaluacion == 1 ? true : false" :calificacionsup="true" :medioano="datosEv.medioano == 1 ? true : false" :finano="true"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="data.idturno == user.emp.id ? true: false"/>
                  <calificacion :comobj="datosObj" :tipo="'Objetivos'" :valor="datosEv.bobjetivos" v-if="objEval"/>
                </v-tab-item>

                <v-tab-item v-if="comentarios.length > 0">
                  <coment :comentarios="comentarios"/>
                </v-tab-item>

                <v-tab-item>
                  <archivos :archivos="soportes" @cargaArchivos="cargaArchivos($event)" :respaldo="datosEv.res_fir_sup"/>
                </v-tab-item>
            </v-tabs>
            <br><br>
            <v-row>

              <v-col cols="6" v-if="datosEv.medioano == 1">
                Evaluacion medio Año del supervisor: {{autoescala2}}
              </v-col>
              <v-col cols="6">
                Evaluacion fin de Año del Supervisor: {{autoescala4}}
              </v-col>              
              
              <v-col cols="8">
                <v-checkbox v-model="firma2" label="Acepto este proceso de evaluacion y certifico que estoy conforme" v-if="data.idturno == user.emp.id"></v-checkbox>
              </v-col>
              <v-col cols="4">
                <v-btn absolute dark bottom right color="success" :disabled="!firma2" @click="observaciones(pev_fir_sup+1)" v-if="enviarPaso1 & data.idturno == user.emp.id & date >= datosEv.fechainicio_fir_sup">
                  Firmar y Finalizar la Evaluacion
                </v-btn>                        
              </v-col>
            </v-row>
          
        </v-stepper-content>

        <v-stepper-content :step="pev_completado">
            <v-tabs>
                <v-tab align-with-title="true" v-if="evcompetencias > 0" @click="rep('com')">
                    <v-icon left>mdi-elevation-rise</v-icon>
                    Competencias ({{sumCom}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="evobjetivos > 0" @click="rep('obj')">
                    <v-icon left>mdi-code-equal</v-icon>
                    Objetivos ({{sumObj}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="comentarios.length > 0">
                    <v-icon left>mdi-comment-multiple-outline</v-icon>
                    Comentarios
                </v-tab>
             <v-tab style="align-content: flex-start;">
                    <v-icon left>mdi-folder-multiple</v-icon>
                    Respaldos
                </v-tab>

                <v-tab-item v-if="evcompetencias > 0">
                  <objcom :datosObjCom="datosCom" :editable="false" :escala="escala" :calificacioncol="datosEv.autoevaluacion == 1 ? true : false" :calificacionsup="true" :medioano="datosEv.medioano == 1 ? true : false" :finano="true"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="false"/>
                  <calificacion :comobj="datosCom" :tipo="'Competencias'" :valor="datosEv.bcompetencias" v-if="comEval"/>
                </v-tab-item>

                <v-tab-item v-if="evobjetivos > 0">
                  <objcom :datosObjCom="datosObj" :editable="false" :escala="escala" :calificacioncol="datosEv.autoevaluacion == 1 ? true : false" :calificacionsup="true" :medioano="datosEv.medioano == 1 ? true : false" :finano="true"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="false"/>
                  <calificacion :comobj="datosObj" :tipo="'Objetivos'" :valor="datosEv.bobjetivos" v-if="objEval"/>
                </v-tab-item>

                <v-tab-item v-if="comentarios.length > 0">
                  <coment :comentarios="comentarios"/>
                </v-tab-item>

                <v-tab-item>
                  <archivos :archivos="soportes" @cargaArchivos="cargaArchivos($event)" :respaldo="0"/>
                </v-tab-item>                
            </v-tabs>
            <br><br>
            <v-row>
              <v-col cols="6" v-if="datosEv.medioano == 1">
                Evaluacion medio Año del supervisor: {{autoescala2}}
              </v-col>
              <v-col cols="6">
                Evaluacion fin de Año del Supervisor: {{autoescala4}}
              </v-col>              
            </v-row>
          
        </v-stepper-content>

        <v-stepper-content step="10">
            <v-tabs>
                <v-tab align-with-title="true" v-if="evcompetencias > 0" @click="rep('com')">
                    <v-icon left>mdi-elevation-rise</v-icon>
                    Competencias ({{sumCom}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="evobjetivos > 0" @click="rep('obj')">
                    <v-icon left>mdi-code-equal</v-icon>
                    Objetivos ({{sumObj}}%)
                </v-tab>
                <v-tab style="align-content: flex-start;" v-if="comentarios.length > 0">
                    <v-icon left>mdi-comment-multiple-outline</v-icon>
                    Comentarios
                </v-tab>
             <v-tab style="align-content: flex-start;">
                    <v-icon left>mdi-folder-multiple</v-icon>
                    Respaldos
                </v-tab>

                <v-tab-item v-if="evcompetencias > 0">
                  <objcom :datosObjCom="datosCom" :editable="false" :escala="escala" :calificacioncol="datosEv.autoevaluacion == 1 ? true : false" :calificacionsup="true" :medioano="datosEv.medioano == 1 ? true : false" :finano="true"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="false"/>
                  <calificacion :comobj="datosCom" :tipo="'Competencias'" :valor="datosEv.bcompetencias" v-if="comEval"/>
                </v-tab-item>

                <v-tab-item v-if="evobjetivos > 0">
                  <objcom :datosObjCom="datosObj" :editable="false" :escala="escala" :calificacioncol="datosEv.autoevaluacion == 1 ? true : false" :calificacionsup="true" :medioano="datosEv.medioano == 1 ? true : false" :finano="true"
                  @newCom="newCom($event)" @editItem="editItem($event)" @deleteItem="deleteItem($event)" @puntuar="puntuar($event)" :comAct="false"/>
                  <calificacion :comobj="datosObj" :tipo="'Objetivos'" :valor="datosEv.bobjetivos" v-if="objEval"/>
                </v-tab-item>

                <v-tab-item v-if="comentarios.length > 0">
                  <coment :comentarios="comentarios"/>
                </v-tab-item>

                <v-tab-item>
                  <archivos :archivos="soportes" @cargaArchivos="cargaArchivos($event)" :respaldo="0"/>
                </v-tab-item>                
            </v-tabs>
            <br><br>
            <v-row>
              <v-col cols="6" v-if="datosEv.medioano == 1">
                Evaluacion medio Año del supervisor: {{autoescala2}}
              </v-col>
              <v-col cols="6">
                Evaluacion fin de Año del Supervisor: {{autoescala4}}
              </v-col>              
            </v-row>
          
        </v-stepper-content>        
    </v-stepper-items>
</v-stepper>

    </v-card>

    <v-dialog v-model="dialog" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center"> 
              
              <v-col cols="12">
                <v-text-field v-model="editedItem.nombre" label="Ingrese un nombre especifico*" required outlined></v-text-field>
                <v-row>
                  <v-col cols="6">
                    <v-btn color="blue darken-1" text v-if="editedIndex == -1" @click="diccionario = true">Importar desde Biblioteca</v-btn>
                  </v-col>
                  <v-col cols="6" style="text-align: right;">
                    <v-btn color="green darken-1" text v-if="editedIndex == -1" @click="diccionariodef = true">Explorar otras Bibliotecas</v-btn>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12">
                  <v-textarea v-model="editedItem.descripcion" outlined label="Ingrese la Descripcion*" rows="2"></v-textarea>
              </v-col>

              <v-col cols="12">
                  <v-textarea v-model="editedItem.casoexito" outlined label="Criterio de Exito" rows="2"></v-textarea>
              </v-col>

              <v-col cols="12">
                  <v-textarea v-model="editedItem.resultados" outlined label="Resultados" rows="2"></v-textarea>
              </v-col>

              <v-col cols="12">
                  <v-textarea v-model="editedItem.categoria" outlined label="Categoria" rows="2"></v-textarea>
              </v-col>              

                <v-col cols="3">
                    <v-text-field type="number"  min="1" max="100" prefix="%" v-model="editedItem.peso" label="Peso" required outlined value="0"></v-text-field>
                </v-col>
              <v-col cols="3">
                  <v-select :items="status" v-model="editedItem.status" label="Estatus" outlined></v-select>
              </v-col>

              <v-col cols="3">
                <v-text-field v-model="editedItem.fecinicio" label="Fecha Inicio" readonly required outlined @click="fechas('inicio')" ></v-text-field>
              </v-col>

              <v-col cols="3">
                <v-text-field v-model="editedItem.fecfin" label="Fecha Fin" readonly required outlined @click="fechas('fin')"></v-text-field>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="presave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-dialog ref="dialog" v-model="modal" persistent width="290px">
        <v-date-picker v-model="date" scrollable v-if="dialogofType=='inicio'" :max="datosEv.fechafin" :min="datosEv.fechainicio" @input="fechasave(dialogofType)">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
          <v-btn text color="primary" @click="fechasave(dialogofType)">OK</v-btn>
        </v-date-picker>


        <v-date-picker v-model="date" scrollable v-if="dialogofType=='fin'" :max="datosEv.fechafin" :min="datosEv.fechainicio" @input="fechasave(dialogofType)">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
          <v-btn text color="primary" @click="fechasave(dialogofType)">OK</v-btn>
        </v-date-picker>
      </v-dialog>

    <v-dialog v-model="dialogPaso" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Observaciones</span>
        </v-card-title>
        <v-card-subtitle class="d-flex justify-center">
          <v-avatar  size="100">
            <v-img :src="user.emp.imagen_usuario" alt="Institucion">
          </v-img>
          </v-avatar>
        </v-card-subtitle>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                  <v-textarea v-model="obs" outlined label="Observaciones" rows="2"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="obsSend">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-dialog v-model="diccionario" max-width="600px">
        <v-card>
          <v-toolbar color="primary" dark>
              <v-toolbar-title aling="center">Diccionario de {{this.apiPathUse == 'competencia' ? 'Competencias' : 'Objetivos'}}</v-toolbar-title>
            </v-toolbar>
            <v-card flat>

              <v-card-text>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
                <v-data-table
                  :headers="headersdic"
                  :items="(this.apiPathUse == 'competencia') ? comdic : objdic"
                  :items-per-page="5"
                  class="elevation-1"
                  :search="search"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon small @click="copiar(item)">mdi-forward</v-icon>
                    
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <v-card-actions>
            
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="diccionario = false">Cancelar</v-btn>
            
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="diccionariodef" max-width="600px">
        <v-card>
          <v-toolbar color="primary" dark>
              <v-toolbar-title aling="center">Biblioteca de {{this.apiPathUse == 'competenciainstitucion' ? 'Competencias' : 'Objetivos'}}</v-toolbar-title>
            </v-toolbar>
            <v-card flat>

              <v-card-text>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
                <v-data-table
                  :headers="headersdic"
                  :items="(this.apiPathUse == 'competencia') ? comdef : objdef"
                  :items-per-page="5"
                  class="elevation-1"
                  :search="search"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon small @click="copiar(item)">mdi-forward</v-icon>
                    
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <v-card-actions>
            
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="diccionariodef = false">Cancelar</v-btn>
            
          </v-card-actions>
        </v-card>
      </v-dialog>

    <v-bottom-sheet v-model="sheet" persistent>
      <v-sheet >
        <v-toolbar color="primary" dark>
          <v-toolbar-title aling="center">{{ editedItem.nombre }}</v-toolbar-title>
        </v-toolbar>
      <v-card>
        <v-card-text>
          <v-container>
            <v-row align="center"> 
              <v-col cols="6">
                <v-row align="center"> 
                  <v-col cols="12">
                    Nombre: {{ editedItem.descripcion }}
                  </v-col>
                  <v-col cols="12">
                    Resultados: {{ editedItem.resultados }}
                  </v-col>
                  <v-col cols="12">
                    Caso de Exito: {{ editedItem.casoexito }}
                  </v-col>
                  <v-col cols="12">
                    Categoria: {{ editedItem.categoria }}
                  </v-col>
                  <v-col cols="4">
                    Peso: {{ editedItem.peso }}%
                  </v-col>
                  <v-col cols="4">
                    Fecha Inicio: {{ editedItem.fecinicio }}
                  </v-col>
                  <v-col cols="4">
                    Fecha Fin: {{ editedItem.fecfin }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <div style="height: 100px; overflow-y: scroll;">
                    <div style="padding:4px; background:#fff;" v-for="com in editedItem.comentario" :key="com.id">
                      {{com.comentario}}
                    </div>
                </div>
                <v-row>
                  <v-col cols="11">
                    <v-textarea v-model="nuevoCom" outlined label="Comentarios" rows="1"></v-textarea>
                  </v-col>
                  <v-col cols="1" class="d-flex justify-center">
                    <v-icon @click="newCom">mdi-arrow-right-drop-circle-outline</v-icon>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div class="d-flex justify-center">
              <v-btn class="mt-6" color="primary" dark @click="sheet = !sheet" >Ok</v-btn>
            </div>
          </v-container>
        </v-card-text>
      </v-card>

      </v-sheet>
    </v-bottom-sheet>

  </div>
</template>
<script>
import axios from "axios"
import api from "../conf/ruta-base"
import store from "../store"
import UserProfile from '../data'
import coment from '../components/comentarios'
import objcom from '../components/objcom'
import calificacion from '../components/calificacion'
import archivos from '../components/archivos'
import moment from "moment"
import swal from 'sweetalert'
moment.locale('es')
export default {
  name: "evaluacion",
  components: {
    coment, objcom, archivos, calificacion
  },
  //Declaramos las variables que vamos a utilizar
  data: () => ({
    apiPath: "evaluacion", apiPathObj: "objetivo", apiPathCom: "competencia", apiPathUse: '', responsable: [], evaluado: [], api: api.api,
    dialog: false, dialog2: false, modal: false, dialogoType: "", dialogofType: "", dialogPaso: '', sheet: false,
    envio: null, obs: '', sumCom: 0, sumObj: 0, date: new Date().toISOString().substr(0, 10), user: UserProfile.getUserData(),
    datos: [], datosEv: [], datosCom: [], datosObj: [], evfecini: '', evfecfin: '', evfinaliza: '', firma1: false, firma2: false, soportes: [],
    evcompetencias: '', evobjetivos: '', evpaso: 0, enviarPaso1: false, evaluacioncolaborador: 0, selec: '', chosenFile: null, archive: null,
    comentarios:[], numPasos: 0, search: "", data: null, nuevoCom: '', escala: [], autoescala: null, autoescala2: null, autoescala3: null, autoescala4: null, info: null,
    //Generamos las variables que gestionaran los pasos a nivel de pantalla
    pflujo: 1, prevision: 2, pev_med_col: 80, pev_med_sup: 81, pev_fin_col: 82, pev_fin_sup: 83, pev_fir_col: 84, pev_fir_sup: 85,
    headers: [
      { text: "Nombre", align: "start", sortable: true, value: "nombre" },
      { text: "Descripción", value: "descripcion" }, { text: "Peso", value: "peso" }, { text: "Fecha Inicio", value: "fecinicio" },
      { text: "Fecha Fin", value: "fecfin" }, { text: "Estatus", value: "dstatus" }, { text: "Actions", value: "actions", sortable: false }
    ],
    headersPaso2: [
      { text: "Nombre", align: "start", sortable: true, value: "nombre" }, { text: "Valor", value: "peso" },
      { text: "Periodo", value: "fechas" }, { text: "Estatus", value: "dstatus" }, { text: "Actions", value: "actions", sortable: false }
    ],
    headersdic: [
      { text: "Competencia", align: "start", sortable: true, value: "nombre" },
      { text: "Descripción", sortable: true, value: "descripcion" },
      { text: "Actions", value: "actions", sortable: false }
    ],
    pasos: [], turno: [], evaobj: [], evacom: [], editedIndex: -1, comdic:[], objdic:[], comdef:[], objdef:[], diccionario: false, diccionariodef: false,
    editedItem: { id: '', nombre: '', descripcion: '', peso: '', fechainicia: '', fechafin: '',
      status: 1, fecinicio: '', fecfin: '', dstatus: '', asignado: 0, },
    defaultItem: { id: '', nombre: '', descripcion: '', peso: '', fechainicia: '', fechafin: '',
      status: 1, fecinicio: '', fecfin: '', dstatus: '', asignado: 0, },
    status: [{text:'No Iniciado',value:0},{text:'Iniciado',value:1},{text:'Detenido',value:2},{text:'Finalizado',value:3}],
    idcol: 0, objEval: false, comEval: false,
  }),
  mounted() {
    //Consultamos la Evaluacion que se esta trabajando...
    if(this.$route.params.idcol){
      this.idcol = this.$route.params.idcol
    }else{
      this.idcol = this.user.emp.id
    }
    //Nos traemos los datos de la evaluacion
    let id = this.$route.params.id
    axios
      .get(api.api + this.apiPath + '/mievaluacion/' + id + '/' +this.idcol)
      .then(r => {
            r.data=r.data[0]
            this.evfecini = moment(r.data.evacol.fechainicio).format('L');
            this.evfecfin = moment(r.data.evacol.fechafin).format('L');
            this.evcompetencias = r.data.evacol.vcompetencias;
            this.evobjetivos = r.data.evacol.vobjetivos;
            this.apiPathUse = (r.data.evacol.vcompetencias > 0) ? this.apiPathCom : this.apiPathObj
            //this.evfinaliza = moment().endOf(r.data.fechafin).fromNow();
            this.data = r.data
            //this.evpaso = parseInt(r.data.paso)
            this.responsable.name=r.data.turno.nombres + ' ' + r.data.turno.apellidos
            this.responsable.img=r.data.turno.imagen_usuario
            this.evaluado.name=r.data.emp.nombres + ' ' + r.data.emp.apellidos
            this.evaluado.img=r.data.emp.imagen_usuario
            this.datosEv=r.data.evacol
            this.datosEv.emp=r.data.emp
            //Creamos los pasos
            //Paso1
            let paso
            this.numPasos++
            paso = {step: ''+this.numPasos+'', descrip: 'Fijación de Objetivos', listo:r.data.paso>this.numPasos?true:false}
            this.pasos.push(paso)
            this.pflujo = this.numPasos
            this.turno[this.numPasos] = 'emp'
            //Paso2
            this.numPasos++
            paso = {step: this.numPasos, descrip: 'Revisión y Seguimiento de Objetivos', listo:r.data.paso>this.numPasos?true:false}
            this.pasos.push(paso)
            this.prevision = this.numPasos
            this.turno[this.numPasos] = 'sup'
            //Evaluamos si la opcion de medio año y autoevaluacion esta activada
            if(r.data.evacol.medioano==1 & r.data.evacol.autoevaluacion==1){
              this.numPasos++
              paso = {step: this.numPasos, descrip: 'Evaluación Medio Año Colaborador', listo:r.data.paso>this.numPasos?true:false}
              this.pasos.push(paso)
              this.pev_med_col = this.numPasos
              this.turno[this.numPasos] = 'emp'
            }
            //Evaluamos si esta activa la opcion de medio año para supervisor
            if(r.data.evacol.medioano==1){
              this.numPasos++
              paso = {step: this.numPasos, descrip: 'Evaluación Medio Año Supervisor', listo:(r.data.paso>this.numPasos)?true:false}
              this.pasos.push(paso)
              this.pev_med_sup = this.numPasos
              this.turno[this.numPasos] = 'sup'
            }
            //Evaluamos si la opcion de medio año y supervision matricial esta activada
            if(r.data.evacol.medioano==1 & r.data.evacol.sup_matricial==1){
              this.numPasos++
              paso = {step: this.numPasos, descrip: 'Evaluación Medio Año Supervisor Matricial', listo:r.data.paso>this.numPasos?true:false}
              this.pasos.push(paso)
              this.pev_med_col = this.numPasos
              this.turno[this.numPasos] = 'mat'
            }            
            
            //Evaluamos si la opcion autoevaluacion esta activada para colaborador
            if(r.data.evacol.autoevaluacion==1){
              this.numPasos++
              paso = {step: this.numPasos, descrip: 'Evaluación Final Colaborador', listo:r.data.paso>this.numPasos?true:false}
              this.pasos.push(paso)
              this.pev_fin_col = this.numPasos
              this.turno[this.numPasos] = 'emp'
            }
            
            //Paso evaluacion Supervisor Fijo
            this.numPasos++
            paso = {step: this.numPasos, descrip: 'Evaluación Final Supervisor', listo:r.data.paso>this.numPasos?true:false}
            this.pasos.push(paso)
            this.pev_fin_sup = this.numPasos
            this.turno[this.numPasos] = 'sup'
            
            //Evaluamos si la opcion supervision matricial esta activada
            if(r.data.evacol.sup_matricial==1){
              this.numPasos++
              paso = {step: this.numPasos, descrip: 'Evaluación Final Supervisor Matricial', listo:r.data.paso>this.numPasos?true:false}
              this.pasos.push(paso)
              this.pev_med_col = this.numPasos
              this.turno[this.numPasos] = 'mat'
            }
            
            //Procesos de Calibración
            this.numPasos++
            paso = {step: this.numPasos, descrip: 'Calibración', listo:r.data.paso>this.numPasos?true:false}
            this.pasos.push(paso)
            this.pev_fir_col = this.numPasos
            this.turno[this.numPasos] = 'sup'
            
            //Procesos de Retroalimentación
            this.numPasos++
            paso = {step: this.numPasos, descrip: 'Retroalimentación', listo:r.data.paso>this.numPasos?true:false}
            this.pasos.push(paso)
            this.pev_fir_col = this.numPasos
            this.turno[this.numPasos] = 'emp'

            //Procesos de Firma
            this.numPasos++
            paso = {step: this.numPasos, descrip: 'Firma del Colaborador', listo:r.data.paso>this.numPasos?true:false}
            this.pasos.push(paso)
            this.pev_fir_col = this.numPasos
            this.turno[this.numPasos] = 'emp'
            
            this.numPasos++
            paso = {step: this.numPasos, descrip: 'Firma del Supervisor', listo:r.data.paso>this.numPasos?true:false}
            this.pasos.push(paso)
            this.pev_fir_sup = this.numPasos
            this.turno[this.numPasos] = 'sup'

            this.numPasos++
            paso = {step: this.numPasos, descrip: 'Completado', listo:r.data.paso>this.numPasos?true:false}
            this.pasos.push(paso)
            this.pev_completado = this.numPasos
            this.turno[this.numPasos] = 'emp'
            this.turno[10] = 'sup'
            this.autoescala = r.data.calificacion_col
            this.autoescala2 = r.data.calificacion_sup
            this.autoescala3 = r.data.calificacionfin_col
            this.autoescala4 = r.data.calificacionfin_sup
            this.evpaso = parseInt(r.data.paso)
            //Llamamos al metodo de objetivos y comentarios
            this.cargarMiObjCom()
            this.cargarObservaciones(id)
      })
      .catch(error => {
        console.log(error);
      });
  },

  watch: {
    //Liberamos la variable temporal de edited
      dialog(valor){
          if(!valor){
            this.$nextTick(() => {
              this.editedItem = Object.assign({}, this.defaultItem);
              this.editedIndex = -1;
            });
          }
      },
      //Evaluamos el paso
      evpaso(paso){
        this.evaluar()
      },
      //Sumamos las competencias
      sumCom(){
          this.evaluar()
      },
      //Sumamos los objetivos
      sumObj(){
          this.evaluar()
      },
      //Procesamos los archivos
      archive(){
        this.chosenFile = this.archive.archiveFile
      },
      //Cargamos el paso de la evaluacion y validamos si es 10 es decir si esta rechazada
      evpaso(){
          if(this.evpaso==10){
            for(let i = 0; i < this.pasos.length; i++){
              this.pasos[i].rechazo = true
            }
          let paso = {step: 10, descrip: 'Rechazado', listo:false, rechazo:true,}
          this.pasos.push(paso)
          this.responsable.name = 'Recursos Humanos'
          this.responsable.img = ''
        }
      }
  },

  computed: {
    //Computamos el titulo
    formTitle() {
      let tit = (this.apiPathUse == 'competencia') ? 'Competencia' : 'Objetivo'
      return this.editedIndex === -1 ? tit : "Modificar "+tit
    },
  },

  methods: {

    cargarMiObjCom(){
    //Consultamos los objetivos asociados a esa Evaluacion
    let id = this.$route.params.id
    axios
      .get(api.api + this.apiPathObj+'/evaluacion/'+id+'/'+this.idcol)
      .then(r => {
        for (let i = 0; i < r.data.length; i++) {
          let cal = {
            id: r.data[i].id,
            calificacionmed_col: r.data[i].calificacionmed_col,
            calificacionmed_sup: r.data[i].calificacionmed_sup,
            calificacionfin_col: r.data[i].calificacionfin_col,
            calificacionfin_sup: r.data[i].calificacionfin_sup,
          }
          this.evaobj.push(cal)
          if(r.data[i].calificacionmed_col > 0 || r.data[i].calificacionmed_sup > 0 || r.data[i].calificacionfin_col > 0 || r.data[i].calificacionfin_sup > 0){
            this.objEval = true
          }
            r.data[i].fecinicio = moment(r.data[i].fechainicia).format('L');
            r.data[i].fecfin = moment(r.data[i].fechafin).format('L');
            r.data[i].fechas = moment(r.data[i].fechainicia).format('L')+" "+moment(r.data[i].fechafin).format('L');
            r.data[i].dstatus = (r.data[i].status==0) ? 'No Iniciado':'Iniciado';
            for(let j = 0; j < r.data[i].comentario.length; j++){
              r.data[i].comentario[j].fecha = moment(r.data[i].comentario[j].fecha).format('L')
            }
          this.sumObj += parseInt(r.data[i].peso)
          this.datosObj.push(r.data[i])
        }
      })
      .catch(error => {
        console.log(error);
      });

    //Consultamos las competencias asociadas a esa Evaluacion
    axios
      .get(api.api + this.apiPathCom+'/evaluacion/'+id+'/'+this.idcol)
      .then(r => {
        for (let i = 0; i < r.data.length; i++) {
          let cal = {
            id: r.data[i].id,
            calificacionmed_col: r.data[i].calificacionmed_col,
            calificacionmed_sup: r.data[i].calificacionmed_sup,
            calificacionfin_col: r.data[i].calificacionfin_col,
            calificacionfin_sup: r.data[i].calificacionfin_sup,
          }
          this.evacom.push(cal)
          if(r.data[i].calificacionmed_col > 0 || r.data[i].calificacionmed_sup > 0 || r.data[i].calificacionfin_col > 0 || r.data[i].calificacionfin_sup > 0){
            this.comEval = true
          }
            r.data[i].fecinicio = moment(r.data[i].fechainicia).format('L');
            r.data[i].fecfin = moment(r.data[i].fechafin).format('L');
            r.data[i].fechas = moment(r.data[i].fechainicia).format('L')+" "+moment(r.data[i].fechafin).format('L');
            r.data[i].dstatus = (r.data[i].status==0) ? 'Inactiva':'Activa';
            for(let j = 0; j < r.data[i].comentario.length; j++){
              r.data[i].comentario[j].fecha = moment(r.data[i].comentario[j].fecha).format('L')
            }
          this.sumCom += parseInt(r.data[i].peso)
          this.datosCom.push(r.data[i]);
        }
      })
      .catch(error => {
        console.log(error);
      });      
    },

    cargarObservaciones(myEvaluacion){
          //Nos traemos los comentarios
      axios
        .get(api.api + 'evaluacioncomentario/evaluacion/' + this.data.id + '/' + this.$route.params.id)
        .then(r => {
          for (let i = 0; i < r.data.length; i++) {
            if(this.data.idcolaborador == r.data[i].idcolaborador){
              r.data[i].alias = 'Colaborador'
            }else{
              r.data[i].alias = 'Supervisor'
            }
            //r.data[i].emp.imagen_usuario = api.api+'uploads/'+r.data[i].emp.imagen_usuario
            this.comentarios.push(r.data[i]);
          }
        })
        .catch(error => {
          console.log(error);
        });
      
      axios
        .get(api.api + 'evaluacion/nivelev/' + myEvaluacion)
        .then(r => {
          for (let i = 0; i < r.data.length; i++) {
            let opcion = {
              text:r.data[i].numero + ' - ' + r.data[i].concepto,
              value:r.data[i].numero
            }
            this.escala.push(opcion);
            
          }
        })
        .catch(error => {
          console.log(error);
        });

      //Nos traemos los archivos cargados como soporte
      axios
        .get(api.api + 'archivo/evaluacion/' + this.data.id + '/' + this.$route.params.id)
        .then(r => {
          for (let i = 0; i < r.data.length; i++) {
            r.data[i].archivo = api.api + 'download/' + r.data[i].archivo
            if(this.data.idcolaborador == r.data[i].idcolaborador){
              r.data[i].alias = 'Colaborador'
            }else{
              r.data[i].alias = 'Supervisor'
            }
            this.soportes.push(r.data[i]);
          }
        })
        .catch(error => {
          console.log(error);
        });

    //Consultamos el diccionario de las competencias
    axios
      .get(api.api + 'comdic/dic')
      .then(r => {
        for (let i = 0; i < r.data.length; i++) {
          if(r.data[i].institucion>0){
            this.comdic.push(r.data[i])
          }else{
            this.comdef.push(r.data[i])
          }
        }
      })
      .catch(error => {
        console.log(error);
      });  

    //Consultamos el diccionario de los objetivos
    axios
      .get(api.api + 'objdic/dic')
      .then(r => {
        for (let i = 0; i < r.data.length; i++) {
          if(r.data[i].institucion>0){
            this.objdic.push(r.data[i])
          }else{
            this.objdef.push(r.data[i])
          }
        }
      })
      .catch(error => {
        console.log(error);
      }); 
    },
    //Editamos la evaluacion
    editItem(item) {
      this.editedIndex = (this.apiPathUse == 'competencia') ? this.datosCom.indexOf(item) : this.datosObj.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    //Asignamos el item a edited
    verItem(item) {
      this.editedIndex = (this.apiPathUse == 'competencia') ? this.datosCom.indexOf(item) : this.datosObj.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.sheet = true;
    },
    //Cerramos el dialogo
    close() {
      this.dialog = false;
      this.dialogPaso = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    //Validamos los datos
    presave(){
      let bandera = true
      let err = ''
        if(bandera && this.editedItem.descripcion.length == 0){
          bandera = false
          err = 'Debe ingresar un nombre descriptivo.'
        }

        if(bandera && (this.editedItem.fecinicio.length == 0 || this.editedItem.fecfin.length == 0)){
          bandera = false
          err = 'Debe especificar las fechas de Inicio y Fin del Proceso'
        }
  
        if(bandera && (this.editedItem.casoexito.length == 0 || this.editedItem.resultados.length == 0)){
          bandera = false
          err = 'Faltan datos relevantes'
        }

        if(bandera && (this.editedItem.nombre.length == 0 || this.editedItem.peso.length == 0)){
          bandera = false
          err = 'Verifique el nombre o el peso'
        }

      if(bandera){
        this.save()
      }else{
        swal('',err,'error');
      }
      
    },
    //Salvamos la informacion
    save() {
      if (this.editedIndex > -1) {
        if(this.apiPathUse == 'competencia'){
          let sumCom = parseInt(this.sumCom) - parseInt(this.datosCom[this.editedIndex].peso) + parseInt(this.editedItem.peso)
          if(sumCom > 100)
          {
            swal('',`La suma de las competencias esta en ${sumCom}% del 100% permitido`,'error');
            return null
          }
            Object.assign(this.datosCom[this.editedIndex], this.editedItem);
            this.sumCom = parseInt(sumCom)  
        }else{
          let sumObj = parseInt(this.sumObj) - parseInt(this.datosObj[this.editedIndex].peso) + parseInt(this.editedItem.peso)
          if(sumObj > 100)
          {
            swal('',`La suma de los objetivos esta en ${sumObj}% del 100% permitido`,'error');
            return null
          }
            Object.assign(this.datosObj[this.editedIndex], this.editedItem);
            this.sumObj = parseInt(sumObj)
        }
        this.editedItem.emp = this.user.emp.id
        axios
          .put(api.api + this.apiPathUse, this.editedItem)
          .then(res => {
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
      } else {
          if(this.apiPathUse != 'competencia'){
            let sumObj = parseInt(this.sumObj) + parseInt(this.editedItem.peso)
            if(sumObj > 100){
              swal('',`La suma de los objetivos esta en ${sumObj}% del 100% permitido`,'error');
              return null
            }
          }else{
            let sumCom = parseInt(this.sumCom) + parseInt(this.editedItem.peso)
            if(sumCom > 100){
              swal('',`La suma de las competencias esta en ${sumCom}% del 100% permitido`,'error');
              return null
            }
          }        
        this.editedItem.evaluacion = this.$route.params.id
        this.editedItem.emp = this.user.emp.id
        axios
          .post(api.api + this.apiPathUse+'/'+this.idcol, this.editedItem)
          .then(r => {
            r.data.fecinicio = moment(r.data.fechainicia).format('L');
            r.data.fecfin = moment(r.data.fechafin).format('L');
            r.data.dstatus = (r.data.status==0) ? 'No Iniciado':'Iniciado';
            if(this.apiPathUse == 'competencia'){
                this.sumCom += parseInt(r.data.peso)
                this.datosCom.push(r.data);
                let cal = {
                  id: r.data.id,
                  calificacionmed_col: 0,
                  calificacionmed_sup: 0,
                  calificacionfin_col: 0,
                  calificacionfin_sup: 0,
                }
                this.evacom.push(cal)
            }else{
                this.sumObj += parseInt(r.data.peso)
                this.datosObj.push(r.data);
                let cal = {
                  id: r.data.id,
                  calificacionmed_col: 0,
                  calificacionmed_sup: 0,
                  calificacionfin_col: 0,
                  calificacionfin_sup: 0,
                }
                this.evaobj.push(cal)
            }
            this.toast(r.data.c, r.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
      }
      this.close();
    },
    //Borramos la informacion
    deleteItem(item) {
      const index = (this.apiPathUse == 'competencia') ? this.datosCom.indexOf(item) : this.datosObj.indexOf(item);
      swal({text: "¿Seguro que desea eliminar?",icon: "warning", buttons: ["Cancelar", "Ok"],})
      .then(ok => {         
        if(ok){
          axios.delete(api.api + this.apiPathUse, {data: item})
          .then(res => {
            if(res.data.c=='success'){
                if(this.apiPathUse == 'competencia'){
                    this.sumCom -= parseInt(item.peso)
                    this.datosCom.splice(index, 1)
                    for(let i = 0; i < this.evacom.length; i++){
                      if(this.evacom[i].id == item.id){
                        this.evacom.splice(i, 1)
                        break
                      }
                    }
                }else{
                    this.sumObj -= parseInt(item.peso)
                    this.datosObj.splice(index, 1)
                    for(let i = 0; i < this.evaobj.length; i++){
                      if(this.evaobj[i].id == item.id){
                        this.evaobj.splice(i, 1)
                        break
                      }
                    }
                }
            }
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
        }
      })
    },
    //Aletas
    toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
    },
    //Creamos las variables temporales que mostraran la fecha en español
    fechas(evento){
        this.dialogofType = evento;
        this.modal = true;
    },
    //Pasamos la fecha en español a la fecha como debe ser almacenada
    fechasave(evento){
        let [year, month, day] = this.date.split('-')
        let date = day.padStart(2, '0') + '/' + month.padStart(2, '0') + '/' + year;
        if(evento=='inicio'){
          this.editedItem.fecinicio = date;
          this.editedItem.fechainicia = this.date;
        }else if(evento=='medio'){
          this.editedItem.fecmedio = date;        
          this.editedItem.fechamedio = this.date;
        }else if(evento=='fin'){
            this.editedItem.fecfin = date;
            this.editedItem.fechafin = this.date;
        }
        this.dialogofType = '';
        this.modal = false;
        this.date = new Date().toISOString().substr(0, 10);
    },
    //Analizamos en donde nos encontramos si en competencia o objetivos
    rep(tipo){
        this.apiPathUse = (tipo=='com') ? this.apiPathCom : this.apiPathObj
    },
    //Validamos antes de incluir las obervaciones
    observaciones(paso=null,coment=null){
      let banderaObj = true
      let banderaCom = true
      if(this.sumObj>0 && coment){
        for(let i = 0; i < this.datosObj.length; i++){
          let bantemp = false
          for(let y = 0; y < this.datosObj[i].comentario.length; y++){
            if(this.datosObj[i].comentario[y].etapa == this.evpaso && this.datosObj[i].comentario[y].idcolaborador == this.user.emp.id){
              bantemp = true
              break
            }
          }
          if(bantemp){
            banderaObj = true
          }else{
            banderaObj = false
          }
        }
      }
      if(this.sumCom>0 && coment){
        for(let i = 0; i < this.datosCom.length; i++){
          let bantemp = false
          for(let y = 0; y < this.datosCom[i].comentario.length; y++){
            if(this.datosCom[i].comentario[y].etapa == this.evpaso && this.datosCom[i].comentario[y].idcolaborador == this.user.emp.id){
              bantemp = true
              break
            }
          }
          if(bantemp){
            banderaCom = true
          }else{
            banderaCom = false
          }
        }
      }      
      if(banderaCom && banderaObj){
        if(paso){
          this.envio = paso
        } 
        this.dialogPaso = true
      }else{
        swal('',`Existen Objetivos/Competencias sin comentarios en esta etapa`,'error');
      }
    },
    //Evaluamos que las condiciones esten Ok
    evaluar(){
        if(this.evcompetencias > 0 & this.evobjetivos > 0){
          if(this.sumCom == 100 & this.sumObj == 100){
            this.enviarPaso1 = true
          }else{
            this.enviarPaso1 = false
          }
        }
        
        if(this.evcompetencias > 0 & this.evobjetivos == 0){
          if(this.sumCom == 100){
            this.enviarPaso1 = true
          }else{
            this.enviarPaso1 = false
          }          
        }
        
        if(this.evcompetencias == 0 & this.evobjetivos > 0){
          if(this.sumObj == 100){
            this.enviarPaso1 = true
          }else{
            this.enviarPaso1 = false
          }          
        }
    },
    //Enviamos al paso indicado
    enviarPaso(level){
        var idencargado = (this.turno[level] == 'sup') ? this.data.emp.idsupervisor : this.data.idcolaborador
        var params = {
          obs: this.obs,
          id:parseInt(this.data.id),
          idencargado,
          evaluacioncol: this.autoescala,
          evaluacionsup: this.autoescala2,
          evaluacionfincol: this.autoescala3,
          evaluacionfinsup: this.autoescala4,
        }
        axios
        .put(api.api + this.apiPath+'/paso/'+level, params)
        .then(res => {
            this.evpaso = res.data.paso
            this.data.idturno = res.data.idturno
            this.responsable.name = res.data.paso == 10 ? 'Recursos Humanos' : res.data.turno.nombres + ' ' + res.data.turno.apellidos
            this.toast(res.data.c, res.data.mensaje)
            this.obs = null
        })
        .catch(error => {
            console.log(error);
        });
        this.envio = null
    },
    //Enviamos las observaciones
    obsSend(){
        if(this.obs.length <= 10){
          swal('',`Debe agregar una observacion detallada`,'error');
          return null}
        let params = {
          etapa: this.evpaso,
          ev: this.$route.params.id,
          idevaluacioncolaborador: this.data.id,
          idcolaborador: this.user.emp.id,
          comentario: this.obs,
          fecha: new Date().toISOString().substr(0, 10),
          objetivos: this.datosObj.length,
          competencias: this.datosCom.length,
          xobjetivos: this.datosEv.bobjetivos,
          xcompetencias: this.datosEv.bcompetencias,
        }
        let detailCom=[]
        for(let i = 0; i < this.datosCom.length; i++){
          let detalle = {
            nombre: this.datosCom[i].nombre,
            valor: this.datosCom[i].peso,
            med_col: this.datosCom[i].calificacionmed_col || 0,
            med_sup: this.datosCom[i].calificacionmed_sup || 0,
            fin_col: this.datosCom[i].calificacionfin_col || 0,
            fin_sup: this.datosCom[i].calificacionfin_sup || 0,
          }
          detailCom.push(detalle)
        }
        params.detailCom = detailCom
        let detailObj=[]
        for(let i = 0; i < this.datosObj.length; i++){
          let detalle = {
            nombre: this.datosObj[i].nombre,
            valor: this.datosObj[i].peso,
            med_col: this.datosObj[i].calificacionmed_col || 0,
            med_sup: this.datosObj[i].calificacionmed_sup || 0,
            fin_col: this.datosObj[i].calificacionfin_col || 0,
            fin_sup: this.datosObj[i].calificacionfin_sup || 0,
          }          
          detailObj.push(detalle)
        }
        params.detailObj = detailObj        
        
        axios
        .post(api.api + 'evaluacioncomentario/', params)
        .then(res => {
            if(this.data.idcolaborador == res.data.idcolaborador){
              res.data.alias = 'Colaborador'
            }else{
              res.data.alias = 'Supervisor'
            }
            this.comentarios.push(res.data); //Aqui se envia el comentario para que lo muestre.
            this.close()
            this.toast(res.data.c, res.data.mensaje);
            if(this.envio){
               this.enviarPaso(this.envio)
            }else{
              console.log('Valor del paso no valido ',this.envio)
            }
        })
        .catch(error => {
            console.log(error);
        });
    },
    //Convertimos la fecha en español
    momento(fecha){
      return moment(fecha).format('L')
    },
    //Calculamos el tiempo que falta para finalziar la evaluacion en español (Computar)
    faltan(){
      let now = moment(this.date)
      let end = moment(this.datosEv.fechafin)
      let duration = moment.duration(end.diff(now));
      let days = Math.round(duration.asDays());
      return days
    },
    //Trabajamos el nuevo comentario
    newCom(com){
      let params = {
        ev: this.$route.params.id,
        id: com.id,
        comentario: com.nuevoCom,
        fecha: new Date().toISOString().substr(0, 10),
        etapa: this.evpaso,
      }
        axios
        .post(api.api + this.apiPathUse + '/comentario', params)
        .then(res => {
          com.comentario = new Array()
          for(let i =  0; i < res.data.length; i++){
            res.data[i].fecha = moment(res.data[i].fecha).format('L')
            res.data[i].nombre = res.data[i].colaborador[0].nombres + ' ' + res.data[i].colaborador[0].apellidos
            if(this.data.idcolaborador == res.data[i].colaborador[0].id){
              res.data[i].alias = 'Colaborador'
            }else{
              res.data[i].alias = 'Supervisor'
            }
            com.comentario.push(res.data[i])
          }
        })
        .catch(error => {
            console.log(error);
        });
    },
    //Cargamos el archivo nuevo
    cargaArchivos(arc){
        let file = new FormData()
        let opt = {
          headers: {
            'Accept': 'application/json','Content-Type': 'multipart/form-data',
          }
        }
        file.append('soporte',arc,arc.name)
        file.append('id',this.data.id)
        file.append('etapa',this.evpaso)
        file.append('ev',this.$route.params.id)
        axios
          .post(api.api + 'archivo', file, opt)
          .then(res => {
            res.data.archivo = api.api + 'download/' + res.data.archivo
            console.log('No se que le pasa',res.data.idcolaborador)
            if(this.data.idcolaborador == res.data.idcolaborador){
              res.data.alias = 'Colaborador'
            }else{
              res.data.alias = 'Supervisor'
            }
            this.soportes.push(res.data)
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
    },
    //Evaluamos la tarjeta o completo
    puntuar(item){
      let working = (this.apiPathUse == 'competencia') ? this.evacom : this.evaobj
        for(let i = 0; i < working.length; i++){
          if(working[i].id==item.id){
            if(item.calificoA=='calificacionmed_col')
              working[i].calificacionmed_col = item.puntocol
            if(item.calificoA=='calificacionmed_sup')
              working[i].calificacionmed_sup = item.puntosup
            if(item.calificoA=='calificacionfin_col')
              working[i].calificacionfin_col = item.puntocol
            if(item.calificoA=='calificacionfin_sup')
              working[i].calificacionfin_sup = item.puntosup
          }
        }
    },
    //Copiamos la competencia o el objetivo desde el diccionario
    copiar(item){
      this.editedItem.nombre = item.nombre
      this.editedItem.descripcion = item.descripcion
      this.editedItem.casoexito = item.casoexito
      this.editedItem.resultados = item.resultados
      this.editedItem.peso = item.peso
      this.diccionario = false
      this.diccionariodef = false
    },
    //Validamos las evaluaciones segun correspondan.
    validarcal(tipo,paso,global=null){
      console.log('ObjCom',this.datosObj)
      console.log('Eva',this.evaobj)
      let bandera = true
        if(tipo=='medsup' && this.autoescala2 == 0){
          bandera = false
        }
        if(tipo=='finsup' && this.autoescala4 == 0){
          bandera = false
        }

      for(let i = 0; i < this.evacom.length; i++){
        if(tipo=='medcol' && this.evacom[i].calificacionmed_col == 0){
          bandera = false
          break
        }
        if(tipo=='medsup' && this.evacom[i].calificacionmed_sup == 0){
          bandera = false
          break
        }
        if(tipo=='fincol' && this.evacom[i].calificacionfin_col == 0){
          bandera = false
          break
        }
        if(tipo=='finsup' && this.evacom[i].calificacionfin_sup == 0){
          bandera = false
          break
        }
      }

      for(let i = 0; i < this.evaobj.length; i++){
        if(tipo=='medcol' && this.evaobj[i].calificacionmed_col == 0){
          bandera = false
          break
        }
        if(tipo=='medsup' && this.evaobj[i].calificacionmed_sup == 0){
          bandera = false
          break
        }
        if(tipo=='fincol' && this.evaobj[i].calificacionfin_col == 0){
          bandera = false
          break
        }
        if(tipo=='finsup' && this.evaobj[i].calificacionfin_sup == 0){
          bandera = false
          break
        }
      }

      if(global && global == 0){
        bandera = false
      }

      if(bandera){
        if(this.evaobj.length > 0){
          axios
          .put(api.api + 'objetivo/calificar', this.evaobj)
          .then(res => {
            this.toast(res.data.c, res.data.mensaje)
            for(let i = 0; i < this.datosObj.length; i++){
              for(let y = 0; y < this.evaobj.length; y++){
                if(this.datosObj[i].id==this.evaobj[y].id){
                  this.datosObj[i].calificacionmed_col = this.evaobj[y].calificacionmed_col
                  this.datosObj[i].calificacionmed_sup = this.evaobj[y].calificacionmed_sup
                  this.datosObj[i].calificacionfin_col = this.evaobj[y].calificacionfin_col
                  this.datosObj[i].calificacionfin_sup = this.evaobj[y].calificacionfin_sup
                  break
                }
              }
            }
          })
          .catch(error => {
            console.log(error);
          });
        }
        if(this.evacom.length > 0){
          axios
          .put(api.api + 'competencia/calificar', this.evacom)
          .then(res => {
            this.toast(res.data.c, res.data.mensaje)
            for(let i = 0; i < this.datosCom.length; i++){
              for(let y = 0; y < this.evacom.length; y++){
                if(this.datosCom[i].id==this.evacom[y].id){
                  this.datosCom[i].calificacionmed_col = this.evacom[y].calificacionmed_col
                  this.datosCom[i].calificacionmed_sup = this.evacom[y].calificacionmed_sup
                  this.datosCom[i].calificacionfin_col = this.evacom[y].calificacionfin_col
                  this.datosCom[i].calificacionfin_sup = this.evacom[y].calificacionfin_sup
                  break
                }
              }
            }
          })
          .catch(error => {
            console.log(error);
          });
        }
      this.observaciones(paso,true)
      }else{
        swal('',`Existen objetivos o competencias sin calificar`,'error');
      }
    }
  }
};
</script>